<template>
  <section class="container">
    <div class="header">
      <div class="avatar-container bigimg">
        <!-- <div class=""> -->
        <img
          class="avatar"
          alt="Sebastian's Avatar"
          src="../assets/Seb-Avatar.png"
        />
        <!-- </div> -->
      </div>
      <div>Sebastian Frank</div>
    </div>

    <div class="side">
      <div class="sidebar" v-for="s in sidebar" :key="s">
        <div class="side-label">{{ s.category }}</div>
        <div v-for="c in s.subsections" :key="c">
          <div v-if="c.type !== 'WEBSITES'">
            <div class="side-type">{{ c.type }}</div>
            <ul class="side-info" v-for="i in c.info" :key="i">
              <li>{{ i }}</li>
            </ul>
          </div>
          <div v-if="c.type === 'WEBSITES'">
            <div class="side-type">{{ c.type }}</div>
            <div class="side-info" v-for="i in c.info" :key="i">
              <span style="margin-left: 10px">{{ i.name }}</span>
              <!-- <li>
                <a :href="i.link" target="_blank" rel="noopener">
                </a>
              </li> -->
              <ul>
                <li>
                  <a :href="i.link" target="_blank" rel="noopener">
                    {{ i.link }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="main">
      <div class="blurb education">
        <div class="category">Education</div>
        <div class="chunk" v-for="e in education" :key="e">
          <div class="sub-category">
            <div>
              {{ e.school }}
              <span class="inset">
                <a
                  class="link"
                  v-if="e.link !== null && e.link !== ''"
                  :href="e.link"
                  target="_blank"
                  rel="noopener"
                  >link</a
                >
              </span>
            </div>
          </div>
          <div class="sub-category-details">
            <div class="blurb-item">{{ e.item }}</div>
            <div class="blurb-date">{{ e.date }}</div>
          </div>
          <div v-if="e.detail1 !== null && e.detail1 !== ''" class="blurb">
            {{ e.detail1 }}
          </div>
          <div v-if="e.detail2 !== null && e.detail2 !== ''" class="blurb">
            {{ e.detail2 }}
          </div>
        </div>
      </div>
      <div class="blurb work">
        <div class="category">Work Experience</div>
        <div class="chunk" v-for="e in work" :key="e">
          <div class="sub-category">
            <div>
              {{ e.company }}
              <span class="inset">
                <a
                  class="link"
                  v-if="e.link !== null && e.link !== ''"
                  :href="e.link"
                  target="_blank"
                  rel="noopener"
                  >link</a
                >
              </span>
            </div>
          </div>
          <div class="sub-category-details">
            <div class="blurb-item">{{ e.job }}</div>
            <div class="blurb-date">{{ e.date }}</div>
          </div>
          <div v-if="e.detail1 !== null && e.detail1 !== ''" class="blurb">
            {{ e.detail1 }}
          </div>
          <div v-if="e.detail2 !== null && e.detail2 !== ''" class="blurb">
            {{ e.detail2 }}
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="blurb">blurb</div> -->
    <!-- <div class="blurb">blurb</div> -->

    <div class="footer"></div>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  data() {
    return {
      education: [
        {
          school: "University of Wisconsin—Madison",
          item: "Masters Literary Studies",
          date: "2011",
          detail1:
            "Dissertation: “Bureaucracy and American Literature” (unfinished)",
          detail2: null,
          link: "",
        },
        {
          school: "University of Illinois – Urbana-Champaign",
          item: "BA with Honors",
          date: "2001",
          detail1: "Major: English",
          detail2: "Minor: East Asian Languages and Cultures",
          link: "",
        },
        {
          school: "中央民族大学 (Zhōngyāng Mínzú Dàxúe) - Beijing, PRC",
          item: "Study Abroad",
          date: "1998 - 1999",
          detail1: "",
          detail2: "",
          link: "https://www.muc.edu.cn/",
        },
        {
          school: "University of Colorado – Boulder",
          item: "[transfered to U of I]",
          date: "1995 - 1998",
          detail1: "Major: Chinese",
          detail2: "Minor: English",
          link: "",
        },
        {
          school: "Phillips Academy—Andover, Massachusetts",
          item: "High School Diploma",
          date: "1995",
          detail1: null,
          detail2: null,
          link: "",
        },
      ],
      work: [
        {
          company: "Green Mountain Insulated Glass",
          job: "Inspector",
          date: "2021",
          detail1: null,
          detail2: null,
          link: "https://www.greenmtninsulatedglass.com/",
        },
        {
          company: "H. Hirschmann, Ltd.",
          job: "Woodworker",
          date: "2020 - 2021",
          detail1: null,
          detail2: null,
          link: "https://hhirschmannltd.com/",
        },
        {
          company: "Freelance",
          job: "Editor",
          date: "2018 - 2020",
          detail1: null,
          detail2: null,
          link: "",
        },
        {
          company: "Mount Holly School Board",
          job: "Director",
          date: "2015 - 2021",
          detail1: "Chair—Vermont Act 46 Study Committee (2015 - 2017)",
          detail2: null,
          link: "",
        },
        {
          company: "Dartmouth University",
          job: "Fellow",
          date: "2010 - 2011",
          detail1: null,
          detail2: null,
          link: "",
        },
        {
          company: "University of Wisconsin - Madison",
          job: "Teaching & Research Assistant",
          date: "2005 - 2008",
          detail1: null,
          detail2: null,
          link: "",
        },
      ],
      contact: [
        {
          type: "PHONE",
          info1: "802-259-3121 (h)",
          info2: "802-558-9557 (m)",
        },
      ],
      sidebar: [
        {
          category: "LANGUAGES",
          subsections: [
            {
              type: "Mandarin",
              info: ["Beginner"],
            },
            {
              type: "French",
              info: ["Intermediate"],
            },
            {
              type: "Spanish",
              info: ["Reading"],
            },
          ],
        },
        {
          category: "HOBBIES",
          subsections: [
            {
              type: "Coding",
              info: ["HTML", "CSS", "Javascript", "Vue"],
            },
            {
              type: "Reading",
              info: ["1000+ audiobooks"],
            },
          ],
        },
        {
          category: "CONTACT",
          subsections: [
            {
              type: "PHONE",
              info: ["802-259-3121 (h)", "802-558-9557 (m)"],
            },
            {
              type: "WEBSITES",
              info: [
                {
                  name: "Resume",
                  link: "https://polkadotrodeo.web.app/",
                },
                {
                  name: "Periodic Delirium",
                  link: "https://periodic-delirium.web.app/",
                },
                {
                  name: "Foamy",
                  link: "http://valuable-interest.surge.sh/",
                },
              ],
            },
            {
              type: "EMAIL",
              info: ["sebnoah@gmail.com"],
            },
          ],
        },
      ],
    };
  },
};
</script>

<style>
@media print {
  .container {
    display: grid;
    width: 100%;
    max-width: 8.5in;
    margin: 0 auto;
    grid-template-columns: 1.85in 0.125in 2.75in 2.75in 0;
    /* grid-template-rows: 1.25in 2in 5.75in 2in; */
    grid-template-rows: 1.5in 3.5in 3.5in 1.5in;
    grid-template-areas:
      "header   header  header   header gutter"
      ".    split   main     main   gutter"
      "side     split   main     main   gutter"
      "footer   footer  footer   footer gutter";
  }

  .header {
    align-items: center;
    grid-area: header;
    font-size: 0.65in;
    display: grid;
    grid-template-columns: 1fr 5fr;
    padding: 0 0 15px 0;
  }

  .avatar {
    max-width: 0.75in;
  }

  .category {
    font-size: 0.25in;
  }

  .sub-category {
    font-size: 0.15in;
    padding: 0 0 0 5px;
  }

  .link {
    font-size: 0.12in;
    display: none;
    text-decoration: none;
    color: #2c3e50;
  }
  a:link {
    text-decoration: none;
    color: #2c3e50;
  }

  a:visited {
    text-decoration: none;
    color: #2c3e50;
  }

  a:hover {
    text-decoration: none;
    color: #2c3e50;
  }

  a:active {
    text-decoration: none;
    color: #2c3e50;
  }

  /* .sub-category-details {
    font-size: 0.15in;
    display: grid;
    grid-template-columns: 2fr 1fr;
  } */

  /* .blurb-item {
    padding: 0 0 0 10px;
    font-size: 12px;
    grid-column: span 1;
  }

  .blurb-date {
    padding: 0 20px 0 0;
    text-align: end;
    font-size: 12px;
  }

  .chunk {
    padding: 5px 0 10px 0;
  }

  .blurb {
    padding: 0 0 0 10px;
    font-size: 12px;
  } */
  ul {
    line-height: 100%;
    /* list-style-type: square; */
    list-style-type: disc;
    list-style-position: outside;
    /* padding: 0; */
    margin-block-start: -0.1em;
    margin-block-end: 0.1em;
    margin-inline-start: -15px;
    margin-inline-end: -5px;
  }
  .side-label {
    font-size: 14px;
    font-weight: bold;
  }
  .side-type {
    font-size: 12px;
    margin: 0 0 0 5px;
  }
  .side-info {
    font-size: 11px;
    /* margin: 0 0 0 10px; */
  }
  .side {
    grid-area: side;
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: 1.125in;
  }
  .sidebar {
    display: flex;
    flex-direction: column;
    margin: 0.125in 0 0.25in -0.125in;
  }
}
@media screen {
  .container {
    display: grid;
    width: 100%;
    max-width: 8.5in;
    margin: 0 auto;
    grid-template-columns: 2.75in 3.25in 3.25in;
    grid-template-rows: 1.5in 3.5in 3.5in 1.5in;
    grid-template-areas:
      "header   header   header"
      "blank       main     main"
      "side     main     main"
      "footer   footer   footer";
  }

  .header {
    align-items: center;
    grid-area: header;
    font-size: 0.75in;
    display: grid;
    grid-template-columns: 1fr 4fr;
  }

  /* .main {
    grid-area: main;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
  } */
  /* .side-contact {
    grid-area: contact;
    display: flex;
    flex-direction: column-reverse;
  } */
  /* .contact {
    display: flex;
    flex-direction: column;
  } */

  ul {
    line-height: 50%;
    list-style-type: square;
    margin-block-start: 0.5em;
    margin-block-end: 0.75em;
    margin-inline-start: -10px;
    margin-inline-end: 0px;
  }
  .side-label {
    font-size: 18px;
    font-weight: bold;
  }
  .side-type {
    font-size: 16px;
    margin: 0 0 0 5px;
  }
  .side-info {
    font-size: 14px;
    /* margin: 0 0 0 10px; */
  }
  .avatar {
    max-width: 1.15in;
  }

  /* .avatar-container {
    grid-area: avatar-container;
  } */

  .category {
    font-size: 0.25in;
    padding: 10px 0 0 0;
  }

  .sub-category {
    font-size: 0.15in;
    padding: 0 0 0 10px;
  }

  .link {
    font-size: 0.12in;
  }
  .side {
    grid-area: side;
    display: flex;
    flex-direction: column-reverse;
  }
  .sidebar {
    display: flex;
    flex-direction: column;
    margin: 5px 0;
  }
}
.blurb-item {
  padding: 0 0 0 10px;
  font-size: 12px;
  grid-column: span 1;
}

.blurb-date {
  padding: 0 20px 0 0;
  text-align: end;
  font-size: 12px;
}

.chunk {
  padding: 5px 0 10px 0;
}

.blurb {
  padding: 0 0 0 10px;
  font-size: 12px;
}

.footer {
  /* background: #6a478f10; */
  grid-area: footer;
}
.main {
  grid-area: main;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
}

.container div {
  color: rgb(32, 30, 30);
}

.work {
  background: #b0353210;
}

.education {
  background: #33a8a510;
}

.inset {
  margin: -10px 0;
}

/* .sidebar {
  display: flex;
  flex-direction: column;
  margin: 5px 0;
} */
.sub-category-details {
  font-size: 0.15in;
  display: grid;
  grid-template-columns: 2fr 1fr;
}
</style>
